import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getId } from '../../utils/helperMethods';
import './timeline.scss';

const Timeline = ({ onboardingProcess, isCreate }) => {
    console.log("timeLine onboardingProcess--->", onboardingProcess);
    return(
        <>
        <ul className="timeline">
            {onboardingProcess.map(merchantOnboard => {
                // console.log("inisde TimeLine --> onBoarding", onboardingProcess );
                return(
                    <li
                    id={getId(merchantOnboard.name)}
                    className={`event ${merchantOnboard.status}`}
                    key={merchantOnboard.tabId}
                >
                    {merchantOnboard.status !== 'Complete' &&
                    merchantOnboard.status !== 'Open' ? (
                        <h3>{merchantOnboard.name}</h3>
                    ) : (
                        <Link
                            className={isCreate ? 'disabled' : ''}
                            to={merchantOnboard.path}
                        >
                            <h3>{merchantOnboard.name}</h3>
                        </Link>
                    )}
                </li>
                )
            })}
        </ul>
    </>
    )
};

Timeline.propTypes = {
    isCreate: PropTypes.bool,
    onboardingProcess: PropTypes.array.isRequired,
};

export default Timeline;
